// frontend/src/services/apiService.js (Updated for slug-based endpoints)
import api from "../config/api";

class ApiService {
  // Categories
  async getCategories() {
    const response = await api.get("/categories");
    return response.data;
  }

  async getCategory(categoryId) {
    const response = await api.get(`/categories/${categoryId}`);
    return response.data;
  }

  async getCategoryBySlug(slug) {
    // NEW: Method for slug-based lookup
    const response = await api.get(`/categories/${slug}`);
    return response.data;
  }

  // Videos
  async getVideo(videoId) {
    const response = await api.get(`/videos/${videoId}`);
    return response.data;
  }

  async getVideoBySlug(slug) {
    // NEW: Method for slug-based lookup
    const response = await api.get(`/videos/${slug}`);
    return response.data;
  }

  async getVideoStream(videoId) {
    const response = await api.get(`/videos/${videoId}/stream`);
    return response.data;
  }

  async getVideoStreamBySlug(slug) {
    // NEW: Method for slug-based lookup
    const response = await api.get(`/videos/${slug}/stream`);
    return response.data;
  }

  // Playlists
  async getPlaylist(playlistId) {
    const response = await api.get(`/playlists/${playlistId}`);
    return response.data;
  }

  async getPlaylistBySlug(slug) {
    // NEW: Method for slug-based lookup
    const response = await api.get(`/playlists/${slug}`);
    return response.data;
  }

  async search(query, language = "en", type = "all") {
    const response = await api.get("/search", {
      params: {
        q: query,
        lang: language,
        type: type,
      },
    });
    return response.data;
  }

  // Articles
  async getArticles(language = "de", offset = 0, limit = 20) {
    const response = await api.get("/articles", {
      params: { lang: language, offset, limit }
    });
    return response.data;
  }

  async getMyArticles(language = "de", offset = 0, limit = 20) {
    const response = await api.get("/articles/my", {
      params: { lang: language, offset, limit }
    });
    return response.data;
  }

  async getLatestArticle(language = "de") {
    const response = await api.get("/articles/latest", {
      params: { lang: language }
    });
    return response.data;
  }

  async getArticle(articleId, language = "de") {
    const response = await api.get(`/articles/${articleId}`, {
      params: { lang: language }
    });
    return response.data;
  }

  async getArticleBySlug(slug, language = "de") {
    const response = await api.get(`/articles/slug/${slug}`, {
      params: { lang: language }
    });
    return response.data;
  }

  // Quizzes
  async getQuizzes(language = "de") {
    const response = await api.get("/quizzes", {
      params: { lang: language }
    });
    return response.data;
  }

  async getQuiz(slug, language = "de") {
    const response = await api.get(`/quizzes/${slug}`, {
      params: { lang: language }
    });
    return response.data;
  }

  async startQuiz(quizId, language = "de") {
    const response = await api.post(`/quizzes/${quizId}/start`, {
      language
    });
    return response.data;
  }

  async submitQuizAnswer(attemptId, questionId, answerIds, timeSpent = 0) {
    const response = await api.post(`/quizzes/attempts/${attemptId}/answer`, {
      question_id: questionId,
      answer_ids: Array.isArray(answerIds) ? answerIds : [answerIds],
      time_spent: timeSpent
    });
    return response.data;
  }

  async submitQuiz(attemptId) {
    const response = await api.post(`/quizzes/attempts/${attemptId}/submit`);
    return response.data;
  }

  // Events
  async getEvents(language = "de", options = {}) {
    const { status = "upcoming", limit = 50, offset = 0 } = options;
    const response = await api.get("/events", {
      params: { lang: language, status, limit, offset }
    });
    return response.data;
  }

  async getUpcomingEvents(language = "de", limit = 5) {
    const response = await api.get("/events/upcoming", {
      params: { lang: language, limit }
    });
    return response.data;
  }

  async getMyEvents(language = "de", status = "upcoming") {
    const response = await api.get("/events/my", {
      params: { lang: language, status }
    });
    return response.data;
  }

  async getEvent(slug, language = "de") {
    const response = await api.get(`/events/${slug}`, {
      params: { lang: language }
    });
    return response.data;
  }

  async registerForEvent(slug, participationType = "online") {
    const response = await api.post(`/events/${slug}/register`, {
      participation_type: participationType
    });
    return response.data;
  }

  async cancelEventRegistration(slug) {
    const response = await api.delete(`/events/${slug}/register`);
    return response.data;
  }

  async getEventCalendar(slug, language = "de") {
    const response = await api.get(`/events/${slug}/calendar`, {
      params: { lang: language },
      responseType: "blob"
    });
    return response.data;
  }
}

export default new ApiService();
